export const FIREBASE_CONFIG = {
  apiKey: 'AIzaSyCfn5HKb4Ch5X58nrwFqCeZZlpMlpBoDjE',
  authDomain: 'randomgraill.firebaseapp.com',
  projectId: 'randomgraill',
  storageBucket: 'randomgraill.appspot.com',
  messagingSenderId: '106855021720',
  appId: '1:106855021720:web:fd8d5b428cb1cf9e4ae4ed',
  measurementId: 'G-ZHQ7F4P7VN',
};

export const FONCTIONS_URL = null;

export const DB_NAME = null;

